module.exports = {"launched":"Launched successfully","message":"Test how user data will look like when you get it back","trigger_callback":"Trigger callback"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/devmode.json
// module id = 519
// module chunks = 245 979